import { get } from "services/httpService";

const SERVICE_URLS = {
  getHosts: () => `creators/`,
  getHostDetail: (id) => `creators/${id}`,
  getHostDashboardMetrics: () => `creators/dashboard/metrics/`,
};

export const getHosts = (params) => get(SERVICE_URLS.getHosts(), params);
export const getHostDetail = (id) => get(SERVICE_URLS.getHostDetail(id));
export const getHostDashboardMetrics = (params) =>
  get(SERVICE_URLS.getHostDashboardMetrics(), params);
